const returnCorrectWPUrl = () => {
  if (process.env.REACT_APP_APPURL === 'https://policymogul.com') {
    return 'https://about.policymogul.com';
  } else {
    return 'https://staging-about.policymogul.com';
  }
};

export default returnCorrectWPUrl;
